<template>
    <div>
        <mu-avatar icon="remove"></mu-avatar>
        <label>列表项</label>
    </div>
</template>
<script>
export default {
    name: 'listItem'
}
</script>



// WEBPACK FOOTER //
// listItem.vue?c08b9228